import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand-mist text-brand-ink" data-id="element-182" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-183" data-mp="3azjd9vb0ugb5">
        <h2 id="testimonios" className="font-display text-2xl font-bold leading-tight text-brand-blue sm:text-3xl" data-id="element-184" data-mp="36ypqx6d899kd">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-185" data-mp="2x09vwsb2xg5l">
          De pasar horas buscando materiales a contar con una estructura para
          organizar las clases.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-186" data-mp="v9ydr4zhpj73">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border-2 border-brand-blue/10 bg-white p-2.5 text-left" data-id="element-187" data-mp="q9tvb9f0uee8" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-188" data-mp="m5t1ins1gcrb">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-189" data-mp="7a4yh1yghvp0" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug text-brand-ink/90 sm:text-sm" data-id="element-190" data-mp="14vj07lyx9ioi">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-191" data-mp="q63cyfylnvdk">
                <p className="text-xs font-bold uppercase text-brand-blue" data-id="element-192" data-mp="v5g2x9krpikd">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-brand-muted" data-id="element-193" data-mp="1iu917cov42i5">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-xl border-2 border-dashed border-brand-yellow bg-brand-blue p-3" data-id="element-194" data-mp="1xiisiwe1nkip">
            <CtaButton href={OFFER_ANCHOR} data-id="element-195" data-mp="1og9gg234nj37">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-2 text-xs font-semibold text-white/85" data-id="element-196" data-mp="1jj10871jhp4l">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}